import React from 'react';
import { Box, withStyles } from '@material-ui/core';
import { purple } from 'globals/colors';
import FsBody from 'ui-elements/typography/FsBody';
import { TypographyAllProps } from 'globals/types';

export const TrialBox = withStyles(({ spacing }) => ({
  root: {
    display: 'inline-block',
    background: purple.V5,
    padding: spacing(1.5, 2),
    borderRadius: spacing(1),
  },
}))(Box);

export const InfoWrapperBox = withStyles(({ spacing, palette }) => ({
  root: {
    display: 'inline-block',
    borderTop: `1px solid ${palette.grey[200]}`,
    paddingTop: spacing(2),
  },
}))(Box);

export const ButtonWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);

export const Paragraph = withStyles(() => ({
  root: {},
}))(FsBody);

export const Strong = withStyles(() => ({
  root: {
    fontWeight: 600,
  },
}))((props: TypographyAllProps) => <FsBody {...props} component="span" />);

export const Special = withStyles(({ palette }) => ({
  root: {
    fontWeight: 600,
    fontSize: 18,
    color: palette.primary.main,
  },
}))((props: TypographyAllProps) => <FsBody {...props} component="span" />);
